
export function isRounded(product) {
  /* Ideally we would look at product attributes rather than a title,
  * but this works now
  * TODO: also look for an attribute
  */
  return product.title.includes("Rounded corners")
}



// WEBPACK FOOTER //
// ./src/lib/productAttrs.js